export default "__VITE_ASSET__BRVI9n_m__"